/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerAdminModel } from '../../models/practitioner-admin-model';

export interface AdminPost$Params {
      body?: PractitionerAdminModel
}

export function adminPost(http: HttpClient, rootUrl: string, params?: AdminPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<string>;
    })
  );
}

adminPost.PATH = '/Admin';
